<template lang="pug">

  transition(name="fade")
    #end-screen 
      h1 End Screen 

</template>

<script>


import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import { findWhere } from '@/helpers/ArrayUtils'

export default {

  name: 'endscreen',
  
  components: {},
  
  data() {
    return { 
    }
  },
  
  computed: { },
  
  mounted() { },
  
  beforeDestroy() {},
  
  methods: {
  
  },

  watch: {  

  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#end-screen
  +full()
  +flex-center()



</style>







